import React, { Suspense, lazy } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
// TODO(ds-1138): re-enable after November 9th
// import { QueryClientProvider, QueryClient } from "react-query"
import { Loading } from "@bancacfplus/Loading"
import { Auth0ProviderWithNavigate } from "./auth0/Auth0ProviderWithNavigate"
import { AuthenticationGuard } from "./auth0/AuthenticationGuard"
import { PageLayout } from "./components/PageLayout"
// TODO(ds-1138): re-enable after November 9th
// import { Maintenance } from "./components/Maintenance"
// import { ErrorBoundary } from "./components/ErrorBoundary"
// import { useMaintenanceStatus } from "./hooks/useMaintenanceStatus"
import AuthorizedApolloProvider from "./apollo/AuthorizedApolloProvider"
import DashboardDocuments from "./pages/dashboard-documents"

const Dashboard = lazy(() => import("./pages/dashboard"))
const Documents = lazy(() => import("./pages/documents"))
const Clients = lazy(() => import("./pages/clients"))
const SubmitFee = lazy(() => import("./pages/SubmitFee"))
// TODO(ds-1138): re-enable after November 9th
// const Application = lazy(() => import("./pages/application"))
const SingleDossier = lazy(() => import("./pages/SingleDossier"))
const Prescoring = lazy(() => import("./pages/prescoring"))

// TODO(ds-1138): re-enable after November 9th
// const queryClient = new QueryClient()

export const App = () => {
  // TODO(ds-1138): re-enable after November 9th
  // const { isActive, isLoading, error } = useMaintenanceStatus()
  //
  // if (error) {
  //   return <ErrorBoundary error={error} errorContainer />
  // }
  //
  // if (isLoading) {
  //   return <></>
  // }
  //
  // if (isActive) {
  //   return <Maintenance />
  // }

  return (
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <AuthorizedApolloProvider>
          <Suspense fallback={<Loading />}>
            <Routes>
              {/* TODO(ds-1138): re-enable after November 9th
              <Route
                path="/request-loan"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <QueryClientProvider client={queryClient}>
                        <Application />
                      </QueryClientProvider>
                    )}
                  />
                }
              />
              */}
              <Route
                path="/documents"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <Documents />
                      </PageLayout>
                    )}
                  />
                }
              />
              <Route
                path="/prescoring"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <Prescoring />
                      </PageLayout>
                    )}
                  />
                }
              />
              <Route
                path="/clients"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <Clients />
                      </PageLayout>
                    )}
                  />
                }
              />
              <Route
                path="/submit-fee/:sfid"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <SubmitFee />
                      </PageLayout>
                    )}
                  />
                }
              />
              <Route
                path="/dossier/:sfid"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <SingleDossier />
                      </PageLayout>
                    )}
                  />
                }
              />
              <Route
                path="/dashboard-documents"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <DashboardDocuments />
                      </PageLayout>
                    )}
                  />
                }
              />
              <Route
                path="*"
                element={
                  <AuthenticationGuard
                    component={() => (
                      <PageLayout>
                        <Dashboard />
                      </PageLayout>
                    )}
                  />
                }
              />
            </Routes>
          </Suspense>
        </AuthorizedApolloProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  )
}
